import { useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { api, formatError } from "@/lib/api";

export const EnterpriseCell = ({ u, onSaved }) => {
  const [price, setPrice] = useState(String(u.unit_price_gbp ?? 0.6));
  const [busy, setBusy] = useState(false);
  const k = u.id.slice(0, 8);
  const save = async (enterprise) => {
    const p = Number(price);
    if (!(p >= 0.1 && p <= 0.6)) return toast.error("Price must be between £0.10 and £0.60");
    setBusy(true);
    try {
      onSaved((await api.patch(`/admin/users/${u.id}/enterprise`, { enterprise, unit_price_gbp: p })).data);
      toast.success(`${u.email}: Enterprise ${enterprise ? "on" : "off"} at £${p.toFixed(2)}/letter`);
    } catch (e) {
      toast.error(formatError(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="flex items-center gap-2">
      <Switch data-testid={`admin-enterprise-switch-${k}`} checked={!!u.enterprise} disabled={busy} onCheckedChange={save} />
      <span className="text-xs text-slate-500">£</span>
      <input data-testid={`admin-enterprise-price-${k}`} type="number" step="0.01" min="0.10" max="0.60" value={price} onChange={(e) => setPrice(e.target.value)}
        className="w-16 h-8 px-2 rounded-md border border-slate-200 dark:border-slate-700 bg-transparent text-xs font-mono" />
      <button data-testid={`admin-enterprise-save-${k}`} disabled={busy} onClick={() => save(!!u.enterprise)} className="text-xs underline hover:text-emerald-600">Save</button>
    </div>
  );
};
